import { DeviceToken } from './User';
import { ArrayElement } from '../../../types/types';
import { UserStatus } from './userStatus';

export type FiltersObject = Record<string, any>;

export interface FilterOption<TValue> {
    value: TValue;
    label: string;
    subtitle?: string;
}

export type BaseFilterDetails<TFilters extends FiltersObject> = {
    id: FilterKeys<TFilters>;
    label: string;
    multiple: boolean;
    searchable: boolean;
    searchPlaceholder?: string;
    options: FilterOption<FilterValues<TFilters>>[];
    disableSelectAll?: boolean;
};

export type SearchableFilterDetails<TFilters extends FiltersObject> = BaseFilterDetails<TFilters> & {
    searchTerm?: string;
    searchHandler: (searchTerm: string) => void;
    selectedItems?: FilterValues<TFilters>[];
    selectedOptions?: FilterOption<FilterValues<TFilters>>[];
    selectedOptionsHistory?: FilterOption<FilterValues<TFilters>>[];
};

export type FilterDetails<TFilters extends FiltersObject> = SearchableFilterDetails<TFilters> | BaseFilterDetails<TFilters>;

export type FilterKeys<TFilters extends FiltersObject> = keyof TFilters;

export type FilterValues<TFilters extends FiltersObject> = ArrayElement<TFilters[FilterKeys<TFilters>]>;

export type FilterValue<TFilters extends FiltersObject> = FilterValues<TFilters> | FilterValues<TFilters>[];

export type FilterMultipleValuesCount<TFilters extends FiltersObject> = Partial<Record<FilterKeys<TFilters>, number>>;

export type DomainFilterValue = string;
export type GroupFilterValue = string;

export enum LastSeenFilterValue {
    Last24Hours = 'last24Hours',
    LastWeek = 'lastWeek',
    LastMonth = 'lastMonth',
    LastThreeMonths = 'lastThreeMonths',
    LastSixMonths = 'lastSixMonths',
    LastYear = 'lastYear'
}

export enum MatchingStatusFilterValue {
    Matched = 'matched',
    Unmatched = 'unmatched'
}

export type UsersFilters = {
    status?: UserStatus[];
    token?: DeviceToken['type'][];
    domain?: DomainFilterValue[];
    lastSeen?: LastSeenFilterValue;
    group?: GroupFilterValue[];
    name?: string;
    matchingStatus?: MatchingStatusFilterValue[];
};

export type UsersFilterValues = FilterValues<UsersFilters>;

export type UsersFilterValue = FilterValue<UsersFilters>;

export type UsersFilterKeys = FilterKeys<UsersFilters>;

export type UsersFilterMultipleValuesCount = FilterMultipleValuesCount<UsersFilters>;
